<template>
  <div>
    <LmListV2
      ref='LmInitiatorTypesListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Tipos de Iniciadores',
      gqlField: 'InitiatorTypes',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[InitiatorTypesESSortEnum]) {
      InitiatorTypes(
          titleList: "Listado de Tipos de Iniciadores"
          aggs: []
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/tiposdeiniciadores/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/tiposdeiniciadores/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info",buttonColor:"#17a2b8",enableOnSelectedRows:false,type:"redirect",requestEndpoint:"",requestConfirmation:false}]
          ) {
          count
          searcher
          tableItemsTotal
          titleList
          filter {
            aggregatesToSelect
          }
          table {
            items {
              typeName,typeDescription,isEditable,published,deleted,createdBy,updatedBy,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: ['id', 'typeName', 'typeDescription', 'createdAt', 'updatedAt', 'isEditable', 'published', 'deleted', 'createdBy', 'updatedBy', 'actions'],
      searchOnFieldsToSelected: ['id', 'typeName', 'typeDescription', 'createdAt', 'updatedAt', 'isEditable', 'published', 'deleted', 'createdBy', 'updatedBy', 'actions'],
      items: [
        {
          name: 'id',
          description: 'id'
        },
        {
          name: 'typeName',
          description: 'Nombre'
        },
        {
          name: 'typeDescription',
          description: 'Descripción'
        },
        {
          name: 'createdAt',
          description: 'Creado'
        },
        {
          name: 'updatedAt',
          description: 'Actualizado'
        },
        {
          name: 'isEditable',
          description: 'Es editable'
        },
        {
          name: 'published',
          description: 'Publicado'
        },
        {
          name: 'deleted',
          description: 'En baja lógica'
        },
        {
          name: 'createdBy',
          description: 'Creado por'
        },
        {
          name: 'updatedBy',
          description: 'Actualizado por'
        },
        {
          name: 'actions',
          description: 'Acciones'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'typeName',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'typeDescription',
          label: 'Descripción',
          sortable: false
        },
        {
          key: 'isEditable',
          label: 'Es editable',
          sortable: false
        },
        {
          key: 'published',
          label: 'Publicado',
          sortable: true
        },
        {
          key: 'deleted',
          label: 'En baja lógica',
          sortable: true
        },
        {
          key: 'createdBy',
          label: 'Creado por',
          sortable: false
        },
        {
          key: 'updatedBy',
          label: 'Actualizado por',
          sortable: false
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
